<template>
  <div class="log-page section-main__warp">
    <ioc-table
      ref="crud"
      :data="logTableList"
      :option="option"
      :page="page"
      @search-change="query"
      @search-reset="reset"
      @size-change="sizeChange"
      @current-change="pageChange"
    >
      <template slot="operate" slot-scope="scope">
        <img
          :src="getImgPath(scope.row.fileCode)"
          @click="showViewer(scope.row.fileCode, $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
          width="60"
          height="30"
          style="cursor: pointer"
          class="head_pic"
        />
      </template>
      <template slot="operateView" slot-scope="scope">
        <img
          :src="getImgPath(scope.row.fileCode)"
          @click="showViewer(scope.row.fileCode, $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
          height="40"
          style="cursor: pointer;width:50%"
          class="head_pic"
        />
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="showDetails(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>
  
  <script>
import utils from "@src/common/utils";
import tableOption from "../const/logTable";
import { Bus } from "$utils";
import API from "../api/api";
export default {
  name: "SecurityShift",
  data() {
    return {
      page: {
        pageNo: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: tableOption(this),
      logTableList: [],
      viewerInstance: null,
      viewerPhotos: [],
      logDialogVisible: false,
      queryForm: {},
    };
  },
  created() {
    this.queryLogList();
  },
  methods: {
    reset() {
      this.queryForm = {};
      this.page.pageSize = 10;
      this.queryLogList();
    },
    queryLogList() {
      const params = Object.assign(
        {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
        this.queryForm
      );

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(API.queryLogList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        this.logTableList = response.returnObj.list;
        this.page.total = response.returnObj.total;
      });
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    isDutyFormat(data) {
      if (data.type === "1") {
        return "上岗";
      } else if (data.type === "2") {
        return "下岗";
      } else if (data.type === "3") {
        return "换岗";
      }
    },
    dutyTypesFormat(data) {
      if (data.dutyType === "1") {
        return "值班岗";
      }
    },
    shiftsFormat(data) {
      if (data.shifts === "1") {
        return "00:00-08:00";
      } else if (data.shifts === "2") {
        return "08:00-16:00";
      } else {
        return "16:00-24:00";
      }
    },
    indexMethod(index) {
      return this.pageSize * (this.pageNo - 1) + index + 1;
    },
    selectDutyTypes(value) {
      this.queryForm.dutyType = value;
    },
    showDetails(row, index) {
      this.$refs.crud.rowView(row, index);
    },

    query(param) {
      this.page.pageNo = 1;
      this.queryForm = Object.assign({}, param);
      this.queryLogList();
    },

    sizeChange(pageSize) {
      this.page.pageNo = 1;
      this.page.pageSize = pageSize;
      this.queryLogList();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.queryLogList();
    },
    showViewer(imgs, e) {
      console.log(imgs);
      console.log(e);
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
</style>
  